export enum DeviceType {
  /**
   * PC 端
   */
  PC = 0,

  /**
   * 小程序
   */
  MINI_PROGRAM = 1
}

export const DeviceTypeNameMap = {
  [DeviceType.PC]: 'PC',
  [DeviceType.MINI_PROGRAM]: 'MINI_PROGRAM'
}

export const DeviceTypeTextMap = {
  [DeviceType.PC]: 'PC 端',
  [DeviceType.MINI_PROGRAM]: '小程序'
}
